import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { grey, orange, blue, teal } from '@mui/material/colors';
import CircleIcon from '@mui/icons-material/Circle';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Card1, Card2, Card3, Card4 } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { getOrdeStatisticsThunk } from '../../redux/orderSlice';


const Cards = () => {
    const dispatch = useDispatch()
    const { orderStatistics } = useSelector((state) => state.orders)

    // console.log(orderStatistics);

    const statuses = [
        {
            title: 'New',
            count: orderStatistics?.data?.NEW?.totalCount || 0,
            today: `+${orderStatistics?.data?.NEW?.todayCount || 0} today`,
            icon: <Card1 />,
        },
        {
            title: 'Processing',
            count: orderStatistics?.data?.PROCESSING?.totalCount || 0,
            today: `+${orderStatistics?.data?.PROCESSING?.todayCount || 0} today`,
            icon: <Card2 />,
        },
        {
            title: 'Shipped',
            count: orderStatistics?.data?.SHIPPED?.totalCount || 0,
            today: `+${orderStatistics?.data?.SHIPPED?.todayCount || 0} today`,
            icon: <Card3 />,
        },
        {
            title: 'Delivered',
            count: orderStatistics?.data?.DELIVERED?.totalCount || 0,
            today: `+${orderStatistics?.data?.DELIVERED?.todayCount || 0} today`,
            icon: <Card4 />,
        },
    ];

    useEffect(() => {
        dispatch(getOrdeStatisticsThunk())
    }, [])
    return (
        <Box sx={{ paddingBottom: '16px' }}>
            <Grid container spacing={2}>
                {statuses.map((status, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card sx={{
                            display: 'flex', alignItems: 'flex-start', boxShadow: "none",
                            justifyContent: 'space-between', border: '1px solid #E0E2E7',
                        }}>
                            <CardContent>
                                <Typography variant="subtitle1" color="#777980" fontSize="16px">
                                    {status.title}
                                </Typography>
                                <Typography variant="h5" color="#1D1F2C" sx={{ p: '6px 0' }} fontSize="28px">
                                    {status.count}
                                </Typography>
                                <Typography variant="body2" color="#858D9D" fontSize="14px">
                                    {status.today}
                                </Typography>
                            </CardContent>
                            <Box sx={{ p: 2 }}>{status.icon}</Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Cards;
